const Request = require('@/repositories/request')

class SupervisorAssignment extends Request {
  getByProjectId(projectId) {
    return this.$strapi.$http.$get(
      `/supervisor-assignments/by-project/${projectId}`
    )
  }

  getCollaboratorValidationMetricsByProjectId(projectId) {
    return this.$strapi.$http.$get(
      `/supervisor-assignments/validation-metrics-by-project/${projectId}`
    )
  }

  saveMassiveCollaborators({
    collaboratorsIds,
    supervisorId,
    projectId,
    validationStatus,
    sendInvitationEmail = false,
  }) {
    return this.$strapi.$http.$post(
      '/supervisor-assignments/massive-collaborators',
      {
        collaboratorsIds,
        supervisorId,
        projectId,
        validation_status: validationStatus,
        sendInvitationEmail,
      }
    )
  }

  update(id, params) {
    return this.$strapi['$supervisor-assignments'].update(id, params)
  }

  updateSupervisor({ projectAssignmentId, supervisor }) {
    return this.$strapi['$supervisor-assignments'].update(projectAssignmentId, {
      supervisor,
    })
  }

  updateStatus(projectAssignmentId, validationStatus) {
    return this.$strapi['$supervisor-assignments'].update(projectAssignmentId, {
      validation_status: validationStatus,
    })
  }

  updateMassiveSupervisor({ supervisorAssignmentsIds, supervisorId }) {
    return this.$strapi.$http.$put(
      '/supervisor-assignments/update-massive-supervisor',
      {
        supervisorAssignmentsIds,
        supervisorId,
      }
    )
  }

  deleteByUserAndProject(userId, projectId) {
    return this.$strapi.$http.$delete(
      `/supervisor-assignments/collaborator/${userId}/project/${projectId}`
    )
  }

  deleteBySupervisorAndProject(supervisorId, projectId) {
    return this.$strapi.$http.$delete(
      `/supervisor-assignments/supervisor/${supervisorId}/project/${projectId}`
    )
  }

  findByProjectId(projectId) {
    return this.$strapi.$http.$get(
      `/supervisor-assignments/by-project-id/${projectId}`
    )
  }

  matchSupervisorAssignment(id) {
    return this.$strapi.$http.$post(
      '/supervisor-assignments/match-supervisor-assignment',
      {
        id,
      }
    )
  }

  getValidationStatus(projectId, supervisorId, collaboratorId) {
    return this.$strapi.$http.$get(
      `/users/supervisors/status-validation?project=${projectId}&supervisor=${supervisorId}&collaborator=${collaboratorId}`
    )
  }

  changeSupervisorAssignment(
    projectId,
    oldSupervisorId,
    newSupervisorId,
    collaboratorId
  ) {
    return this.$strapi.$http.$put(
      `/users/collaborators/replace-supervisor-assigned`,
      {
        project: projectId,
        old_supervisor: oldSupervisorId,
        new_supervisor: newSupervisorId,
        collaborator: collaboratorId,
      }
    )
  }
}

module.exports = SupervisorAssignment
